import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IPatientMedication } from 'src/app/models/IPatientMedication';
import { IMedicationMasterData } from 'src/app/models/IMedicationMasterData';
import { IMedicationMasteSignature } from 'src/app/models/IMedicationMasteSignature';
import { IStates } from 'src/app/models/IStates';
import { IStateList } from 'src/app/models/IStateList';
import { IrxProvider } from 'src/app/models/IrxProvider';
import { IERxRefills } from 'src/app/models/IERxRefills';
import { IEligibilityRequestAndResponse } from 'src/app/models/IEligibilityRequestAndResponse';
import { IDrugFormularyDetails, IFormularyMasterData } from 'src/app/models/IDrugFormularyDetails';
import { IEligibilityOrBenefitInfo } from 'src/app/models/IEligibilityOrBenfitInfo';
import { IDrugAllergies } from 'src/app/models/IDrugAllergies';
import { IMedicationAttributeData } from 'src/app/models/IMedicationAttributeData';
import { directDocAttachment, directmessageDTO, IPharmacyDirectory, ProviderSearchRequest } from 'src/app/models/IPharmacyDirectory';
import { IEnabledProvides } from 'src/app/models/IEnabledProviders';
import { IProviderDirectoryRequestDTO } from 'src/app/models/IProviderDirectoryRequestDTO';
import { IEPrescriptionXMLDTO } from 'src/app/models/IEPrescriptionXMLDTO';
import { IMedicationHistoryDTO } from 'src/app/models/IMedicationHistoryDTO';
import { IMHMedicationDispensedDTO } from 'src/app/models/IMHMedicationDispensedDTO';
import { ICityDetails } from 'src/app/models/ICityDetails';
import { IDisplayInteractionMonograph } from 'src/app/models/IDisplayInteractionMonograph';
import { IErxPrescriptionDTO } from 'src/app/models/IErxPrescriptionDTO';
import { IERxHstoryReviewed, IRxReportTrackingConfigration } from 'src/app/models/IERxHstoryReviewed';
import { SigHistory } from 'src/app/models/SigHistory';
import { IAttributes } from 'src/app/models/IAttributes';
import { TrackMedicationSearch } from 'src/app/models/TrackMedicationSearch';
import { IRxRequestChangeDetails } from 'src/app/models/IRxRequestChangeDetails';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { IAuditPatientMedication } from 'src/app/models/IAuditPatientMedication';
import { IPatientVitals } from 'src/app/models/IPatientVitals';
import { EXOAuthTransaction } from 'src/app/models/EXOAuthTransaction';
import { SSsignDetails } from 'src/app/models/SSsignDetails';
import { PrintModel } from 'src/app/models/PrintModel';
import { PcsSurescriptSignatureInfo } from 'src/app/models/PcsSurescriptSignatureInfo';
import { ExostarTransaction } from 'src/app/models/ExoStarTransaction';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { IPDMPPatientScore } from 'src/app/models/IPDMPPatientScore';
import { IERxPDMPReportData } from 'src/app/models/IERxPDMPReportData';
import { IDirections } from 'src/app/models/IDirections';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class RxService {
  temppage: number = 0;
  pageField = [];
  exactPageList: any;

  constructor(private http: HttpClient) { }

  // getActiveMedicationByPatId(patId: number): Observable<IPatientMedication[]> {
  //   // return this.http.get<IPatientMedication[]>(
  //   //   `${configuration.clinicapiUrl + 'Encounter/ActiveMedicationsByPatientId'}?patid=${patId}&&userid=admin&&lgstatus=`);
  //   const postedData={
  //     patid:patId,
  //     userid:encodeURIComponent(sessionStorage.getItem("userId")).toString(),
  //     lgstatus:null,
  //     activeStatus:status
  //   }
  //   return this.http.post<IPatientMedication[]>(
  //     `${configuration.clinicapiUrl + 'Encounter/ActiveMedicationsByPatientId'}`,postedData);
  // }
  getTrackMedications(searchTrackmed: TrackMedicationSearch): Observable<IPatientMedication[]> {
    return this.http.post<IPatientMedication[]>(`${configuration.clinicapiUrl + 'Encounter/MedicationTracker'}`, searchTrackmed, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getAllergyMedicationsWithCodes(searchstr: string, type: string): Observable<IMedicationMasterData[]> {
    const postedData = {
      searchstr: searchstr,
      type: type,
      userid: 'admin',
      medcode: ''
    }
    return this.http.post<IMedicationMasterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/AllergyMedicationsWithCodes'}`, postedData);
  }
  getAuditEncounterMedicationsByPatientId(patId: number): Observable<IPatientMedication[]> {
    return this.http.get<IPatientMedication[]>(
      `${configuration.clinicapiUrl + 'Encounter/AuditEncounterMedications'}?patid=${patId}&&userid=admin`);
  }
  getAllMedicationsMasterData(type: string): Observable<IMedicationMasterData[]> {
    return this.http.get<IMedicationMasterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsMasterData'}?type=${type}&&userid=admin`);
  }
  getAllMedicationsWithCodesBySearch(searchstr: string): Observable<IMedicationMasterData[]> {
    const postedData = {
      searchstr: searchstr,
      userid: 'admin',
      medcode: '',
      ttycode: ''
    }
    return this.http.post<IMedicationMasterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsWithCodes'}`, postedData);
  }

  getNadeanMedicationBySearch(searchstr: string): Observable<string> {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'Encounter/SearchNadeanMedications'}?searchstr=${searchstr}`);
  }

  GetMonthsCSMedication(PatId: number, medicationName: string, encounterid: string, userId: string): Observable<number> {
    const postedData = {
      PatId: PatId,
      MedicationName: medicationName,
      encounterid: encounterid,
      userid: userId
    }
    return this.http.post<number>(
      `${configuration.clinicapiUrl + 'SureScripts/GetMonthsCSMedication'}`, postedData);
  }
  getAllMedicationsMasterSignature(type: string): Observable<IMedicationMasteSignature[]> {
    return this.http.get<IMedicationMasteSignature[]>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsMasterSignature'}?type=${type}&&userid=admin`);
  }
  getPastMedicationsByPatientId(patId: number): Observable<IPatientMedication[]> {
    return this.http.get<IPatientMedication[]>(
      `${configuration.clinicapiUrl + 'Encounter/PastMedicationsByPatientId'}?patid=${patId}&&userid=admin`);
  }
  insertUpdateMedicationDetails(patientMedication: IPatientMedication[]): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(patientMedication)
    }
    // patientMedication.map((x:any)=> x.enddatestring= moment(x.endDate).format())
    // patientMedication.map((x:any)=> x.startdatestring= moment(x.startDate).format())
    // patientMedication.forEach(x=>{x.startDate=x.startDate.toString()})
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/MedicationDetails'}?userid=admin`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  insertMedicationDetails(patientMedication: IPatientMedication[]): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/MedicationDetailsData'}?userid=admin`, patientMedication, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  insertMedicationMasterSignDetails(medicationMasteSignature: IMedicationMasteSignature[]): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/MedicationSignMaster'}?userid=admin`, medicationMasteSignature, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getAllStates(): Observable<IStates[]> {
    return this.http.get<IStates[]>(
      `${configuration.clinicapiUrl + 'Encounter/AllStates'}?userid=admin`);
  }

  getAllCitys(stateId: string): Observable<ICityDetails[]> {
    return this.http.get<ICityDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/AllCities'}?stateId=${stateId}`);
  }
  sendAddProviderRequestTService(requestProvider: IrxProvider, user: string, index: number): Observable<string> {
    const postedData = {
      inputdata: JSON.stringify(requestProvider)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ProviderRequest'}?userid=${user}&&index=${index}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  sendrequestmessagetoSSTService(msg: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/RequestMessagetoSS'}?msg=${msg}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  sendroutingmessagetoSSTService(msg: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/RoutingMessagetoSS'}?msg=${msg}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  receiveRequestmessagesfromSSTService(msg: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ReceiveRequestMessagesfromSS'}?msg=${msg}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  ParseRefillRequestTService(msg: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ReceiveRequestMessagesfromSS'}?str=${msg}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  InsertPrescriptionRefillMessageTService(erxreq: IERxRefills): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/PrescriptionRefillMessage'}`, erxreq, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  send270messagetoSSTService(msg: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ReceiveRequestMessagesfromSS'}?str=${msg}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  AppendRespToInsertEBRequestTService(ReqInfo: IEligibilityRequestAndResponse): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(ReqInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/RespToInsertEBRequest'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  AppendReqToInsertEBRequestTService(ReqInfo: IEligibilityRequestAndResponse): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(ReqInfo)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ReqToInsertEBRequest'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  FormularyDetailsTService(NDC: string, patid: number, PbmName: string, PlanName: string) {
    return this.http.get<IDrugFormularyDetails>(
      `${configuration.clinicapiUrl + 'SureScripts/formularydetails'}?NDC=${NDC}&&patid=${patid}&&PbmName=${PbmName}&&PlanName=${PlanName}`);
  }
  EligibilityorBenefitTService(patid: string, userid: string) {
    return this.http.get<IEligibilityOrBenefitInfo[]>(
      `${configuration.clinicapiUrl + 'SureScripts/alleligibility'}?patid=${patid}&&userid=${userid}`);
  }
  GetDruginteractionsforAllergy(drug: string, patid: number, userid: string) {
    const postedData = {
      drug: drug,
      patid: patid,
      userid: userid
    }
    return this.http.post<IDrugAllergies[]>(
      `${configuration.clinicapiUrl + 'Encounter/DruginteractionsforAllergy'}`, postedData);
  }
  GetMedicationDataTService() {
    return this.http.get<IMedicationAttributeData[]>(
      `${configuration.clinicapiUrl + 'SureScripts/MedicationData'}`);
  }
  GetAllPharmaciesTService(pharmacyType: string, pharmacyName: string, statecode: string, zip: string, cityName: string, pageNo: number) {
    const postedData = {
      pharmacyType: pharmacyType,
      pharmacyName: pharmacyName,
      statecode: statecode,
      zip: zip,
      cityName: cityName,
      pageNo: pageNo
    }
    return this.http.post<IPharmacyDirectory[]>(
      `${configuration.clinicapiUrl + 'SureScripts/Pharmacies'}`, postedData);
  }
  getCountPharmacies(pharmacyType: string, pharmacyName: string, statecode: string, zip: string, cityName: string) {
    const postedData = {
      pharmacyType: pharmacyType,
      pharmacyName: pharmacyName,
      statecode: statecode,
      zip: zip,
      cityName: cityName
    }
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/PharmaciesCount'}`, postedData);
  }
  GetActiveMedicationsByPatientIdTService(pageNo: number, pageSize: number, patid: number, userid: string, status: boolean) {
    const postedData = {
      pageNo: pageNo,
      pageSize: pageSize,
      patid: patid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      lgstatus: null,
      activeStatus: status
    }
    return this.http.post<IPatientMedication[]>(
      `${configuration.clinicapiUrl + 'Encounter/ActiveMedicationsByPatientId'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  EnabledProvidersTService() {
    const posteddata = {
      status: 'active',
      facilityId: sessionStorage.getItem("FacilityId"),
      locationId: sessionStorage.getItem("LocationId")
    }
    return this.http.post<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/EnabledProviders'}`, posteddata);
  }
  EnabledProvidersbyLocationTService(locationId) {
    const posteddata = {
      status: 'active',
      facilityId: sessionStorage.getItem("FacilityId"),
      locationId: locationId// sessionStorage.getItem("LocationId")
    }
    return this.http.post<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/EnabledProviders'}`, posteddata);
  }
  EnabledallProvidersTService() {
    return this.http.get<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/EnabledallProviders'}?status=active&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }
  EnabledLocationTService() {
    return this.http.get<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/GetLocation'}?status=active`);
  }
  GetEnabledProvidersInformationTService(spi: string) {
    return this.http.get<IProviderDirectoryRequestDTO[]>(
      `${configuration.clinicapiUrl + 'SureScripts/EnabledProvidersInformation'}?spi=${spi}`);
  }

  // GetAllMedicationsWithCodesBySearch(searchstr:string,userid:string){
  //   return this.http.get<IMedicationMasterData[]>(
  //     `${configuration.clinicapiUrl + 'Encounter/MedicationsWithCodes'}?searchstr=${searchstr}&&userid=${userid}&&medcode=null&&ttycode=null`);
  // }

  // TransmitErxtoPharmacyTService(presdto: IEPrescriptionXMLDTO, userid: string): Observable<string> {
  //   return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/TransmitErxtoPharmacy'}?userid=${userid}`, presdto, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' }),
  //   });
  // }
  TransmitErxtoPharmacyTService(presdto: string, userid: string, signature?: SSsignDetails): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/TransmitErxtoPharmacy'}?eRxid=${presdto}&&userid=${userid}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&facId=${Number(sessionStorage.getItem("FacilityId"))}`, signature, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  TransmitErxtoPharmacybyIdTService(Epresdata: EXOAuthTransaction, userid: string): Observable<EXOAuthTransaction[]> {
    const posteddata = {
      inputdata: JSON.stringify(Epresdata)
    }
    return this.http.post<EXOAuthTransaction[]>(`${configuration.clinicapiUrl + 'SureScripts/TransmitErxtoPharmacybyid'}?userid=${userid}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GenerateSignatureByPushModeTService(Epresdata: EXOAuthTransaction, userid: string): Observable<EXOAuthTransaction[]> {
    return this.http.post<EXOAuthTransaction[]>(`${configuration.clinicapiUrl + 'ExoStar/GenerateSignByPushMode'}?userid=${userid}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GetSignatureTransactionStatusTService(Epresdata: EXOAuthTransaction): Observable<SSsignDetails> {
    const posteddata = {
      inputdata: JSON.stringify(Epresdata)
    }
    return this.http.post<SSsignDetails>(`${configuration.clinicapiUrl + 'ExoStar/GetSignTransactionStatus'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GenerateSignatureforDenywithNewByPushModeTService(Epresdata: EXOAuthTransaction, userid: string): Observable<EXOAuthTransaction[]> {
    const posteddata = {
      inputdata: JSON.stringify(Epresdata)
    }
    return this.http.post<EXOAuthTransaction[]>(`${configuration.clinicapiUrl + 'ExoStar/GenerateSigforPush_Denywithnew'}?userid=${userid}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  MedicationHistoryTService(Requestinfo: IMedicationHistoryDTO, Reqmore: boolean, userid: string): Observable<any> {
    const posteddata = {
      inputdata: JSON.stringify(Requestinfo)
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'SureScripts/MedicationHistoryData'}?Reqmore=${Reqmore}&&userid=${userid}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  ParseHxTService(msgid: string, mhid: number, userid: string, patientid: number): Observable<any> {
    const postedData = {
      msgid: msgid,
      mhid: mhid,
      userid: userid,
      patientid: patientid
    }
    return this.http.post<any>(`${configuration.clinicapiUrl + 'SureScripts/ParseHxResponse'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  GetMedicationDispensedInfoTService(PatID: number, userid: string) {
    return this.http.get<IMHMedicationDispensedDTO[]>(
      `${configuration.clinicapiUrl + 'SureScripts/MedicationDispensed'}?PatID=${PatID}&&userid=${userid}`);
  }
  GetAllEBAndPBMInfoByPBMTService(patientid: number, userID: string, pbm: string, insName: string) {
    return this.http.get<IEligibilityOrBenefitInfo>(
      `${configuration.clinicapiUrl + 'SureScripts/PBMInformation'}?patientid=${patientid}&&userID=${userID}&&pbm=${pbm}&&insName=${insName}`);
  }

  GetAllPrescriptionRefillsTService(userid: any) {
    return this.http.get<IERxRefills[]>(
      `${configuration.clinicapiUrl + 'SureScripts/PrescriptionRefillMessages'}?userid=${userid}`);
  }
  GetDrugtoDruginteractions(drug: string, patid: number, userid: string) {
    const postedData = {
      drug: drug,
      patid: patid,
      userid: userid
    }
    return this.http.post<IDisplayInteractionMonograph[]>(
      `${configuration.clinicapiUrl + 'Encounter/DruginteractionsforDrugFDB'}`, postedData);
  }

  getMedicationsById(medicationId: string, msgId: string): Observable<IPatientMedication> {
    const postedData = {
      medicationId: medicationId,
      msgId: msgId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IPatientMedication>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsById'}`, postedData);
  }

  getMedicationsByIdforView(medicationId: string, msgId: string): Observable<IPatientMedication> {
    const postedData = {
      medicationId: medicationId,
      msgId: msgId,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IPatientMedication>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsByIdForView'}?`, postedData);
  }

  getMedicationsBySSReqId(ssReqId: number, reqid: number): Observable<IPatientMedication> {
    const postedData = {
      ssrequestId: ssReqId,
      reqid: reqid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString()
    }
    return this.http.post<IPatientMedication>(
      `${configuration.clinicapiUrl + 'Encounter/MedicationsBySSRequestId'}`, postedData);
  }

  GetStatesProviderSSTService(userid: any, locationId: number) {
    return this.http.get<IStateList[]>(
      `${configuration.clinicapiUrl + 'SureScripts/GetProviderStates'}?userid=${encodeURIComponent(userid).toString()}&&locationId=${locationId}`);
  }

  getSSEligibiltyInfoByPatId(patId: number): Observable<IEligibilityOrBenefitInfo[]> {
    return this.http.get<IEligibilityOrBenefitInfo[]>(
      `${configuration.clinicapiUrl + 'Encounter/SSEligibiltiyInfoById'}?patid=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //  Import Medication services
  GetPossibleMedMatchTService(ndccode: any, medName: any, userid: any) {
    const postedData = {
      ndc: ndccode,
      searchstr: medName,
      userid: userid
    }
    return this.http.post<IMedicationMasterData[]>(
      `${configuration.clinicapiUrl + 'Encounter/PossibleMedMatch'}`, postedData);
  }

  SureScriptProvidersLIST(userid: string) {
    return this.http.get<IProviderDirectoryRequestDTO[]>(
      `${configuration.clinicapiUrl + 'SureScripts/SureScriptProviders'}?userid=${encodeURIComponent(userid)}`);
  }
  insertRefillrequestDetails(messaging: IERxRefills, userid: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/SetRefillRequest'}?userid=${userid}&&portal=null`, messaging, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  insertEprescripptionDetails(prescription: IErxPrescriptionDTO): Observable<any> {
    const posteddata = {
      inputdata: JSON.stringify(prescription)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/InsertEPrescription'}?userid=admin`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DisableProviderRequestTService(userid: string, spi: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/DisableProviderRequest'}?userid=${userid}&&spi=${spi}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UpdateIsActiveByPatidTService(medicationId: string, status: boolean): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateIsActiveByPatid'}?medicationId=${medicationId}&&activeStatus=${status}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getpatdrugalleriesbyEncounterId(encId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetDrugallergiesByEncId'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }
  getpatdrugalleriesbyEncounterIdLoc(encId: string, patId: number): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetDrugallergiesByEncIdLocId'}?encId=${encId}&&patId=${patId}`);
    // return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetDrugallergiesByEncIdLocId'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }
  UpdateMedicationStatus(medicationId: string, status: string, type: string): Observable<string> {
    const postedData = {
      medicationId: medicationId,
      status: status,
      type: type
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/UpdateMedicationStatus'}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  insertUpdateRxReviewedDetails(eRxreviewedDetails: IERxHstoryReviewed): Observable<string> {
    // const postedData = {
    //   encounterId:eRxreviewedDetails.encounterId ,
    //   medicationReviewedDate: eRxreviewedDetails.medicationReviewedDate,
    //   medicationViewedReportDate: eRxreviewedDetails.medicationViewedReportDate,
    //   createdBy: eRxreviewedDetails.createdBy ,
    //   patId :eRxreviewedDetails.patId 
    // }
    const postedData = {
      inputdata: JSON.stringify(eRxreviewedDetails)
    }
    //return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/ERxHistoryReviewed'}?userid=admin`, eRxreviewedDetails, {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/ERxHistoryReviewed'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, postedData, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  insertUpdatePDMPReportData(eRxPdmpReportDetails: IERxPDMPReportData): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ERxPDMPReportDetailsInsert'}?userid=admin`, eRxPdmpReportDetails, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getRxReviewedDetailsbyEncounterId(encId: string, patid: string): Observable<IERxHstoryReviewed> {
    return this.http.get<IERxHstoryReviewed>(`${configuration.clinicapiUrl + 'Encounter/ERxHistoryReviewed'}?encid=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&patid=${patid}`);

  }
  getRxReportReviewedDetailsbyEncounterId(encId: string): Observable<IERxPDMPReportData> {
    return this.http.get<IERxPDMPReportData>(`${configuration.clinicapiUrl + 'SureScripts/ERxPDMPReportDetails'}?encounterId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }

  GetMedicationHistoryLastRequestDateTimeTService(patientid: number, userid: string) {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'SureScripts/LastRequestDate'}?patientid=${patientid}&&userid=${encodeURIComponent(userid)}`);
  }

  insertSigHistory(sigHistory: SigHistory): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(sigHistory)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/SigHistory'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getSigHistories(userid: string, medicationId: string) {
    return this.http.get<SigHistory[]>(
      `${configuration.clinicapiUrl + 'Encounter/SigHistory'}?userid=${encodeURIComponent(userid)}&&medicationId=${medicationId}`);
  }

  //******* Insert Custom Drugs */

  insertCustomDrugDetails(customDrugInfo: IAttributes): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/InsertCustomDrugs'}`, customDrugInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  //******************** get Custom Drug Info */
  getCustomDrugDetails(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/GetCustomDrugs'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  //******************** get Clerk Message Templates */
  getClerkMsgTemplatesDetails(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/GetClerkMessageTemplates'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  cancelERXRequest(erxId: number, msgId: string): Observable<any> {
    const postedData = {
      rxId: erxId,
      cancelmsgId: msgId,
      userId: encodeURIComponent(sessionStorage.getItem("userId")),
      locationId: sessionStorage.getItem("LocationId"),
      facId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/CancelRX'}`, postedData);
  }


  sendRefillReqsttoPharmacyTService(erxreq: IERxRefills): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(erxreq)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/RefillRX'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  RefillERXRequest(ssRequestId: number): Observable<any> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'SureScripts/rxRefillrequest'}?ssRequestId=${ssRequestId}`);
  }

  sendRxChangeResponsetoPharmacy(erxreq: IERxRefills): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(erxreq)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/RxChange'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GetLocationbyPrescriberSSTService(userid: any) {
    return this.http.get<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/GetLocationbyPrescriber'}?userid=${encodeURIComponent(userid)}`);
  }
  GetRxRefillDetails(ssrid: number) {
    return this.http.get<IRxRequestChangeDetails>(
      `${configuration.clinicapiUrl + 'SureScripts/RxRequestDetails'}?ssrid=${ssrid}`);
  }

  GetRxChangeDetails(ssrid: number) {
    return this.http.get<IRxRequestChangeDetails>(
      `${configuration.clinicapiUrl + 'SureScripts/RxChangeDetails'}?ssrid=${ssrid}`);
  }

  getPersonalInfo(id: number): Observable<IPersonalInfo> {
    const postedData = {
      patientid: id,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      clientid: 1
    }
    return this.http.post<IPersonalInfo>(
      `${configuration.clinicapiUrl + 'SureScripts/Personal'}`, postedData);
  }

  getFormaularyMasterData(): Observable<IFormularyMasterData[]> {
    return this.http.get<IFormularyMasterData[]>(
      `${configuration.clinicapiUrl + 'SureScripts/FormularyMasterData'}`);
  }

  getAuditMedicationData(medid: string, startdate: string, enddate: string): Observable<IAuditPatientMedication[]> {
    const postedData = {
      medid: medid,
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      startdate: startdate,
      enddate: enddate
    }
    return this.http.post<IAuditPatientMedication[]>(
      `${configuration.clinicapiUrl + 'SureScripts/AuditMedication'}`, postedData);
  }

  getPatientVitalData(patid: number): Observable<IPatientVitals> {
    return this.http.get<IPatientVitals>(
      `${configuration.clinicapiUrl + 'SureScripts/SSPatientVital'}?PatId=${patid}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  InsertRXPrintDetails(printInfo: PrintModel): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/RXPrint'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, printInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  //************ get Batch Rx Information ***/

  // getBatchMedication(patientId: number, providerId: string, encounterId: string,medicationId:string): Observable<IPatientMedication[]> {
  //   const postedData={
  //     patientId:patientId,
  //     providerId:encodeURIComponent(providerId).toString(),
  //     encounterId:encounterId,
  //     medicationId:medicationId,
  //     userid:encodeURIComponent(sessionStorage.getItem("userId")).toString()
  //   }
  //   return this.http.post<IPatientMedication[]>(
  //     `${configuration.clinicapiUrl + 'Encounter/BatchMeds'}`,postedData);
  // }

  getBatchMedication(patientId: number, providerId: string, encounterId: string, medicationId: string): Observable<IPatientMedication[]> {
    return this.http.get<IPatientMedication[]>(
      `${configuration.clinicapiUrl + 'Encounter/BatchMeds'}?patientId=${patientId}&&providerId=${encodeURIComponent(providerId).toString()}&&encounterId=${encounterId}&&medicationId=${medicationId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  batchSignatureTokenTService(Epresdata: EXOAuthTransaction, userid: string): Observable<EXOAuthTransaction[]> {
    return this.http.post<EXOAuthTransaction[]>(`${configuration.clinicapiUrl + 'ExoStar/GenerateBatchSignature'}?userid=${userid}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GenerateBatchSignatureByPushModeTService(Epresdata: EXOAuthTransaction, userid: string): Observable<ExostarTransaction> {
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/GenerateBatchSignatureWithPush'}?userid=${userid}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  GetBatchSignatureTransactionStatusTService(Epresdata: EXOAuthTransaction): Observable<ExostarTransaction> {
    const posteddata = {
      inputdata: JSON.stringify(Epresdata)
    }
    return this.http.post<ExostarTransaction>(`${configuration.clinicapiUrl + 'ExoStar/GetBatchSignatureTransactionStatus'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  SendBatchRxNCTService(Epresdata: EXOAuthTransaction, userid: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/BatchRxNC'}?userid=${userid}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&facId=${Number(sessionStorage.getItem("FacilityId"))}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  SendBatchRxbysoftorhardtokenTService(Epresdata: EXOAuthTransaction, userid: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/BatchRxPH'}?userid=${userid}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&facId=${Number(sessionStorage.getItem("FacilityId"))}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  SendBatchRxbypushmodeTService(Epresdata: EXOAuthTransaction, userid: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/BatchRxPush'}?userid=${userid}`, Epresdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  SaveInprogressSignRequestTService(MedicationId: string, inprogressStatus: boolean): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/SetinprogressSignRequest'}?MedicationId=${MedicationId}&&inprogressStatus=${inprogressStatus}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  DeleteInprogressSignRequestTService(MedicationId: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'ExoStar/DeleteinprogressSignRequest'}?MedicationId=${MedicationId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UpdateERXPrintDetails(erxId: number, medId: string, statusId: string): Observable<number> {
    return this.http.put<number>(`${configuration.clinicapiUrl + 'Encounter/ERXPrint'}?erxid=${erxId}&&medId=${medId}&&statusId=${statusId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  sendreplaceReqsttoPharmacyTService(erxreq: IERxRefills): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/ReplaceRX'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, erxreq, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  TransmitReplaceErxtoPharmacyTService(presdto: string, reqid: number, userid: string, signature?: SSsignDetails): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/TransmitReplacetoPharmacy'}?eRxid=${presdto}&&reqid=${reqid}&&userid=${userid}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&facId=${Number(sessionStorage.getItem("FacilityId"))}`, signature, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  TransmitReplacetoPharmacybyIdTService(Epresdata: EXOAuthTransaction, userid: string): Observable<EXOAuthTransaction[]> {
    const posteddata = {
      inputdata: JSON.stringify(Epresdata)
    }
    return this.http.post<EXOAuthTransaction[]>(`${configuration.clinicapiUrl + 'SureScripts/TransmitReplacetoPharmacybyid'}?userid=${userid}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  getPreviousMedicationPrescriotionStatus(medicationId: string): Observable<any> {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'SureScripts/PreviousMedicationStatus'}?medicationId=${medicationId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  UpdateMedicationPrescriotionStatus(medicationId: string): Observable<any> {
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/UpdateMedicationStatus'}?medicationId=${medicationId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  SurescriptsProvidersTService() {
    return this.http.get<IEnabledProvides[]>(
      `${configuration.clinicapiUrl + 'SureScripts/SurescriptsProviders'}?status=active&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  getPDMPReport(patientId: number, userId: string, locationId: number, dateRange: string) {
    const postdata = {
      patientId: patientId,
      userId: encodeURIComponent(userId).toString(),
      locationId: locationId,
      FacilityId: sessionStorage.getItem("FacilityId"),
      DateRange: dateRange
    }
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/PDMPReport'}`, postdata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }

  getPDMPReportUrl(patientId: number, userId: string, locationId: number) {
    const postdata = {
      patientId: patientId,
      userId: encodeURIComponent(userId).toString(),
      locationId: locationId,
      FacilityId: sessionStorage.getItem("FacilityId")
    }
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/PDMPReportUrl'}`, postdata);
  }

  getPDMPPatientScore(patientId: number) {
    return this.http.get<IPDMPPatientScore[]>(
      `${configuration.clinicapiUrl + 'SureScripts/PDMPPatientScore'}?PatientId=${patientId}`);
  }

  CheckPdmpReportDate(patientId: number) {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'SureScripts/CheckPdmpReportDate'}?PatientId=${patientId}&&FacilityId=${sessionStorage.getItem("FacilityId")}`);
  }
  getPDMPAllAppointmentListtommorrow() {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'SureScripts/LoadAllPDMPScoreForAppointments'}?facilityid=1`);
  }

  //Pagination 
  GetcheckforActiveMedicationsByPatIdMedId(medicationmasterid: string, patid: number) {
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'Encounter/checkforactivemedication'}?medicationmasterid=${medicationmasterid}&&patid=${patid}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' }),
    });
  }
  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }

  GetMedicationCountbyPatId(patid: number, encId: string) {
    return this.http.get<number>(
      `${configuration.clinicapiUrl + 'Encounter/MedCount'}?patId=${patid}&&encId=${encId}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  checkDosageFrequencyPreviousVisit(medicationId: string, encId: string, directions: IDirections): Observable<any> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/CheckDosageFrequency'}?medicationId=${medicationId}&&encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, directions, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getRxReportdetails(): Observable<IRxReportTrackingConfigration[]> {
    return this.http.get<IRxReportTrackingConfigration[]>(`${configuration.clinicapiUrl + 'Encounter/GetRxReportTrackingConfigration'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityId=${sessionStorage.getItem("FacilityId")}`);
  }

  saveRxreportDetails(RXReportRequest: IRxReportTrackingConfigration): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/SetRxReportTrackingConfigration'}`, RXReportRequest, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }


  deleteRxreportDetails(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/deleteRxReportTrackingConfigration'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  GetAllDownloadedProvidersTService(firstname: string, lastname: string, clinicname: string,
    specialty: string, directAddress: string, statecode: string, zip: string, cityName: string, pageNo: number) {
    const postedData: ProviderSearchRequest = {
      firstName: firstname,
      lastName: lastname,
      clinicName: clinicname,
      specialty: specialty,
      directAddress: directAddress,
      statecode: statecode,
      zip: zip,
      cityName: cityName,
      pageNo: pageNo.toString()
    }
    const posteddata = {
      inputdata: JSON.stringify(postedData)
    }
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/SSProviders'}`, posteddata);
  }

  GetAllDownloadedProvidersCountTService(firstname: string, lastname: string, clinicname: string,
    specialty: string, directAddress: string, statecode: string, zip: string, cityName: string) {
    const postedData: ProviderSearchRequest = {
      firstName: firstname,
      lastName: lastname,
      clinicName: clinicname,
      specialty: specialty,
      directAddress: directAddress,
      statecode: statecode,
      zip: zip,
      cityName: cityName,
      pageNo: "0"
    }
    const posteddata = {
      inputdata: JSON.stringify(postedData)
    }
    return this.http.post<any>(
      `${configuration.clinicapiUrl + 'SureScripts/SSProviderCount'}`, posteddata);
  }

  sendDirectmessagetoProvider(directmessageDTO: directmessageDTO): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(directmessageDTO)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/SSDirectMessage'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }
  getDocumentData(docattachment: directDocAttachment): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(docattachment)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/DocData'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }

  generateCDA_DirectMessage(): Observable<any> {
    const posteddata = {
      patientid: sessionStorage.getItem("patientId"),
      encounterId: sessionStorage.getItem("encounterid"),
      userid: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      dnisections: ''
    };
    return this.http.post<any>(`${configuration.clinicapiUrl + 'Encounter/GetCCDAMessage'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
  getRxFillStatusByMedicationId(medicationId: string): Observable<IPatientMedication[]> {
    return this.http.get<IPatientMedication[]>(
      `${configuration.clinicapiUrl + 'Encounter/RxFillStatus'}?stateId=${medicationId}`);
  }

}
